import { render, staticRenderFns } from "./fee-standards-dialog.vue?vue&type=template&id=4e25175e&scoped=true&"
import script from "./fee-standards-dialog.vue?vue&type=script&lang=js&"
export * from "./fee-standards-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25175e",
  null
  
)

export default component.exports